import React, { Component } from 'react';
import styled from 'styled-components';
// import PropTypes from 'prop-types';

const LazyImage = styled.img`
  opacity: 0;
  transition: opacity 0.5s cubic-bezier(0.39, 0.575, 0.565, 1);
`;

export default class LazyLoadImage extends Component {
  constructor(props) {
    super(props);
    this.recheckUpdate = this.recheckUpdate.bind(this);
  }

  componentDidMount() {
    this.observer = new window.IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        if (!this.isDoneLoadImage) {
          const largeImage = new Image();
          largeImage.src = this.lazyImg.dataset.src;
          largeImage.onload = () => {
            if (largeImage && largeImage.src && this.lazyImg && this.lazyImg.src) {
              this.lazyImg.src = largeImage.src;
              this.isLoadedImage = true;
              this.recheckUpdate();
            }
          };
          if (this.lazyImg.dataset.srcset) {
            const largeImage2x = new Image();
            largeImage2x.src = this.lazyImg.dataset.srcset;
            largeImage2x.onload = () => {
              if (largeImage2x && largeImage2x.src && this.lazyImg && this.lazyImg.src) {
                this.lazyImg.srcset = `${largeImage2x.src} 2x`;
                this.isLoadedImage = true;
                this.isLoaded2xImage = true;
                this.recheckUpdate();
              }
            };
          } else {
            this.isLoaded2xImage = true;
            this.recheckUpdate();
          }
          this.observer.unobserve(this.lazyImg);
        }
      }
    }, { threshold: [0.67] });
    setTimeout(() => {
      if (this.lazyImg) {
        this.observer.observe(this.lazyImg);
      }
    }, 100);
  }

  recheckUpdate() {
    if (this.isLoaded2xImage && this.isLoadedImage && !this.isDoneLoadImage) {
      this.lazyImg.style.opacity = 1;
      this.isDoneLoadImage = true;
    }
  }

  render() {
    return (
      <LazyImage
        {...this.props}
        src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
        ref={c => { this.lazyImg = c; }}
      />
    );
  }
}
